import styled from "styled-components";

export const Container = styled.div`
  background-color: var(--section-background);
  padding: 52px 28px 15px;
  width: 100%;
  box-shadow: 0px 3px 5px rgb(0 0 0 / 5%);
  .action-btn {
    display: flex;
    align-items: center;
    gap: 20px;
    .MuiIconButton-root {
      padding: 0;
    }
    svg {
      cursor: pointer;
    }
  }
  @media (max-width: 1174px) {
    padding: 30px 28px 15px;
  }
  @media (max-width: 850px) {
    padding: 13px;
  }
`;
export const TableContainer = styled.div`
  padding: 0 27px 6px;
  width: 100%;
  flex: 1;
  max-height: calc(100vh - 259px);
  overflow: auto;
  .table-head {
    th {
      font-size: 16px;
      :first-child {
        width: 184px;
        text-align: center;
      }
      :last-child {
        text-align: center;
        width: 188px;
      }
    }
  }
  .body {
    td:first-child {
      text-align: center;
    }
  }
  @media (max-width: 1174px) {
    max-height: calc(100vh - 484px);
  }
  @media (max-width: 850px) {
    max-height: calc(100vh - 404px);
  }
`;
export const Heading = styled.div`
  min-height: 53px;
  background: var(--box-header-background);
  border: var(--box-header-border);
  padding: 13px 28px;
  display: flex;
  align-items: center;
  gap: 14px;

  h3 {
    font-weight: 700;
    font-size: 16px;
    line-height: 150.5%;
    color: #000000;
  }
  p {
    font-size: 14px;
    color: #000000b3;
  }
`;

export const BoxContainer = styled.div`
  margin-bottom: 24px;
`;

export const MainSection = styled.div`
  display: flex;
  align-items: flex-start;
  @media (max-width: 1174px) {
    flex-direction: column;
  }
`;
